import { AdobeTracking, DefaultLinkClickData, TrackingService } from '@repo/roche-xx-shared';
import { DefaultDownloadLinkClickEvent } from '@repo/roche-xx-shared/dist/src/tracking/tracking-services/types';
import { RocheUIResponsiveTableEvent } from '@rocheglobal/roche-ui';

export type TrackedPercentage = Record<number, boolean>;

export const rocheResponsiveTableTracking = (event: RocheUIResponsiveTableEvent): void => {
  switch (event.type) {
    case 'link_click':
      trackLinkClickEvent(event);
      break;
    case 'download':
      trackDownloadLinkClickEvent(event);
      break;
    case 'update_sort_by':
      trackUpdateSortByEvent(event);
      break;
    case 'clear_filter':
      trackClearFilterEvent(event);
      break;
    case 'update_filter': {
      trackUpdateFilterEvent(event);
      break;
    }
  }
};

const getDefaultTrackingData = () => {
  return {
    event: 'responsive_table_functions',
    component_name: 'roche-responsive-table',
  };
};

export const trackLinkClickEvent = (event: RocheUIResponsiveTableEvent) => {
  if (event.type !== 'link_click') return;
  const defaultTrackingData = getDefaultTrackingData();
  const adobeTracking: DefaultLinkClickData = {
    url: event.additionalParameters?.click_url || '',
    innerText: event.additionalParameters?.click_text || '',
    name: `link|${event.additionalParameters?.click_text || ''}`,
    type: 'link',
    position: 'content:responsive-table',
    socialMedia: '',
    socialInteraction: '',
  };

  TrackingService.push({
    ...defaultTrackingData,
    event: event.event,
    additionalParameters: {
      click_text: event.additionalParameters?.click_text || '',
      click_url: event.additionalParameters?.click_url || '',
    },
  });

  AdobeTracking(adobeTracking, 'defaultLinkClick');
};

export const trackDownloadLinkClickEvent = (event: RocheUIResponsiveTableEvent) => {
  if (event.type !== 'download') return;
  const defaultTrackingData = getDefaultTrackingData();
  const adobeTracking: DefaultDownloadLinkClickEvent = {
    event: 'downloadLinkClick',
    timestamp: Date.now(),
    name: event.additionalParameters?.file_name || 'unknown',
    format: event.additionalParameters?.file_type || '',
    url: event.value || '',
  };

  TrackingService.push({
    ...defaultTrackingData,
    event: event.event,
    value: event.value,
    additionalParameters: {
      file_type: event.additionalParameters?.file_type || '',
      file_name: event.additionalParameters?.file_name || '',
    },
  });
  AdobeTracking(adobeTracking, 'downloadLinkClick');
};

export const trackClearFilterEvent = (event: RocheUIResponsiveTableEvent) => {
  if (event.type !== 'clear_filter') return;
  const defaultTrackingData = getDefaultTrackingData();

  TrackingService.push({
    ...defaultTrackingData,
    value: event.trackingValue,
  });
};

export const trackUpdateSortByEvent = (event: RocheUIResponsiveTableEvent) => {
  if (event.type !== 'update_sort_by') return;
  const defaultTrackingData = getDefaultTrackingData();

  TrackingService.push({
    ...defaultTrackingData,
    value: event.trackingValue,
    additionalParameters: {
      sortedColumnNr: event.additionalParameters?.sortedColumnNr + 1,
      sortedColumn: event.additionalParameters?.sortedColumn || '',
    },
  });
};

export const trackUpdateFilterEvent = (event: RocheUIResponsiveTableEvent) => {
  if (event.type !== 'update_filter') return;
  const defaultTrackingData = getDefaultTrackingData();

  TrackingService.push({
    ...defaultTrackingData,
    event: event.trackingValue,
    value: event.value,
    additionalParameters: {
      filteredResults: event.additionalParameters?.filteredResults || 0,
    },
  });
};
